import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { commaFormatted, dateFormat } from '../../../utils/transformer.util';
import ReportCard from '../../../components/ReportCard/ReportCard.component';

export default class AR extends PureComponent {
  constructor(props) {
    super(props);

    const date = new Date();
    this.state = {
      from: dateFormat(date, 'DD-MM-YYYY'),
      to: dateFormat(date, 'DD-MM-YYYY'),
      report: [],
      units: [],
      reportType: 'konsolidasi',
      selectedUnit: '',
      selectedPerwakilan: '',
      selectedPos: '',
    };

    this.reportTypes = [
      {
        value: 'konsolidasi', label: 'Konsolidasi',
      },
      {
        value: 'unit', label: 'Per Unit',
      },
    ];
    this.pos = [
      {
        id: 'ypl', title: 'YPL',
      }, {
        id: 'bos', title: 'BOS',
      }, {
        id: 'intern', title: 'Internal',
      },
    ];
    this._getReport = this._getReport.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this._getUnitOptions = this._getUnitOptions.bind(this);
    this._renderReport = this._renderReport.bind(this);
    this._countSummary = this._countSummary.bind(this);
  }

  componentDidMount() {
    const { handleGetPerwakilan, handleGetUnit } = this.props;
    handleGetPerwakilan();
    handleGetUnit();
    // this._getReport();
  }

  async _getReport() {
    const { handleGetBalanceReport, user } = this.props;
    const {
      from,
      to,
      perwakilan_id = null,
      unit_id = null,
    } = this.state;
    let unitId = unit_id;
    if (perwakilan_id === null && unit_id === null) {
      unitId = user.prm_school_units_id;
    }
    const res = await handleGetBalanceReport({
      unitId,
      perwakilan_id,
      from,
      to,

    });

    this.setState(prevState => ({
      ...prevState,
      report: res,
    }));
  }

  _onSearch(val) {
    const {
      from = '',
      to = '',
      perwakilanId = null,
      unitId = null,
    } = val;
    this.setState(prevState => ({
      ...prevState,
      from,
      to,
      perwakilan_id: perwakilanId ? perwakilanId.id : null,
      unit_id: unitId ? unitId.id : null,
    }), () => {
      this._getReport();
    });
  }

  async _getUnitOptions(e) {
    const { handleGetUnit } = this.props;
    const { value, name } = e.target;
    const filters = {
      perwakilan_id: null,
    };
    if (name === 'perwakilan') {
      filters.perwakilan_id = value.id;
    } else if (name === 'reportType' && value === 'unit') {
      filters.perwakilan_id = null;
    }

    const res = await handleGetUnit(filters);
    this.setState({
      units: res,
    });
  }

  _renderReport(type) {
    const { report = [] } = this.state;
    const data = report.filter(o => o.type === type);
    const rows = [];
    data.forEach((item, i) => {
      rows.push(<tr className={`ar_report_row_${item.level}`} key={`ar_report_row_${i}`}>
        { ('total' in item) && (
          <>
            <td colSpan="2" className="total">
              Total {item.description}
            </td>
            <td className="nominal total">
              {item.total ? commaFormatted(item.total) : ''}
            </td>
          </>
        )}
        { !('total' in item) && (
          <>
            <td>
              {item.code}
            </td>
            <td>
              {item.description}
            </td>
            <td className="nominal separator">
              {item.nominal ? commaFormatted(item.nominal) : ''}
            </td>
          </>
        )}
      </tr>);
    });
    return rows;
  }

  _countSummary(type) {
    const { report = [] } = this.state;
    const data = report.filter(o => o.type === type);
    let total = 0;
    total = data.reduce((a, b) => {
      const current = b.nominal || 0;
      return a + current;
    }, 0);

    return commaFormatted(total);
  }

  render() {
    const {
      perwakilan, user, unit,
    } = this.props;
    const { user_group } = user;
    const isPusat = [8, 9, 10, 13, 14, 15].includes(user_group.id);
    const isPerwakilan = [2, 6, 11, 12].includes(user_group.id);
    let role = 'unit';
    if (isPusat) {
      role = 'pusat';
    } else if (isPerwakilan) {
      role = 'perwakilan';
    }

    return (
      <div className="ar-report">
        <ReportCard
          paging={false}
          onSearch={this._onSearch}
          header={(
            <div className="big-book-report__title">
              <h1>Laporan Posisi Keuangan</h1>
            </div>
          )}
          reportTypes={this.reportTypes}
          pos={this.pos}
          perwakilan={isPusat ? perwakilan.list : null}
          units={unit.list}
          role={role}
          onChangeReportType={this._getUnitOptions}
          onChangePerwakilan={this._getUnitOptions}
        >
          <table className="ar-report__table_wrapper">
            <tbody>
              <tr>
                <td width="50%">
                  <table className="ar-report__table">
                    <thead>
                      <tr>
                        <th className="code">Kode</th>
                        <th className="description">Keterangan</th>
                        <th className="nominal">Nominal</th>
                      </tr>
                    </thead>
                    <tbody>
                      { this._renderReport('activa')}
                    </tbody>
                  </table>
                </td>
                <td width="50%">
                  <table className="ar-report__table">
                    <thead>
                      <tr>
                        <th className="code">Kode</th>
                        <th className="description">Keterangan</th>
                        <th className="nominal">Nominal</th>
                      </tr>
                    </thead>
                    <tbody>
                      { this._renderReport('passiva')}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td width="50%">
                  <table className="ar-report__table">
                    <tr className="summary">
                      <td colSpan="2">
                        Total Aktiva
                      </td>
                      <td className="nominal">
                        {this._countSummary('activa')}
                      </td>
                    </tr>
                  </table>
                </td>
                <td width="50%">
                  <table className="ar-report__table">
                    <tr className="summary">
                      <td colSpan="2">
                        Total Passiva dan Ekuitas
                      </td>
                      <td className="nominal">
                        {this._countSummary('passiva')}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </ReportCard>
      </div>
    );
  }
}
AR.propTypes = {
  handleGetPerwakilan: PropTypes.func,
  handleGetUnit: PropTypes.func,
  perwakilan: PropTypes.object,
  user: PropTypes.object,
  unit: PropTypes.object,
  handleGetBalanceReport: PropTypes.func,
};
AR.defaultProps = {
  handleGetPerwakilan: noop,
  handleGetUnit: noop,
  perwakilan: {},
  user: {},
  unit: {},
  handleGetBalanceReport: noop,
};
